import {useState} from "react";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {login, setToken, getSetting} from "../../services";
import {useFormik} from "formik";
import {initialValues, validationSchema} from "../../utils/formsValidator/loginFormValidator";
import {useAuthAction} from "../../context/AuthContext";
import {pushToast} from "../../utils/pushToast";
import Loading from "../../components/Loading";
import InputPassword from "../../components/InputPassword";
import InputNumeric from "../../components/Input/InputNumeric";
import {convertToWesternNumerals} from "../../utils/helper";
import {useEffect} from "react";

export default function Login() {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const setAuth = useAuthAction();
    const loadSetting = async () => {
        try {
            const {data} = await getSetting();
            if(!data.activeApplicationBime) {
                navigate("/coming-soon")
            } else if (data.currentUserId){
                navigate("/")
            } else{
                setIsLoading(false);
            }
        } catch (ex) {
        }
    }

    useEffect(() => {
        setIsLoading(true);
        const dataParam = searchParams.get('data');
        if(dataParam !== "activateTrue") {
            loadSetting();
        } else {
            setIsLoading(false);
        }
    }, []);
    const onSubmit = async (values) => {
        setIsLoading(true);
        try {
            const {userInfo, userPermission,message,status} = await login(values);

            if(status===201){
                console.log(message)
                pushToast(message, "error")
                setIsLoading(false);

            }else {

                if (userInfo.isSuccess) {
                    setToken(userInfo?.data?.token)
                    setAuth({userInfo: userInfo?.data, userPermission});
                    const searchParams = new URLSearchParams(window.location.search);

                    // Check if the "redirect" parameter exists
                    const hasRedirectParameter = searchParams.has('redirect');
                    if (hasRedirectParameter) {
                        const queryString = window.location.search;

                        // Extract the value associated with the "redirect" parameter
                        const redirectValue = queryString.split('redirect=')[1];

                        navigate(redirectValue);
                    } else {
                        navigate('/adv-panel');
                    }
                } else {

                    pushToast(message, "error")
                }
            }
            setIsLoading(false);
        } catch (e) {

            console.log(e);

            if(navigator.onLine){
               navigate("/coming-soon")

            }else{
                pushToast("اینترنت خود را بررسی کنید", "error")
            }
            setIsLoading(false);
        }
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: false,
        validateOnChange: true
    });

    return (
        <>
            {isLoading ? <Loading/> :
            <div className="container bg-blue" >
                <div className="authentication-wrapper authentication-basic container-p-y">
                    <div className="authentication-inner py-4">
                        <div className="card borderRadius50">
                            <div className="card-body">
                                <div className="col-5 app-brand justify-content-center m-auto">
                                    <img src="/images/login-03.svg" />
                                </div>
                                {/*<hr />*/}
                                <h4 className="mb-2 text-center ">ورود به حساب کاربری</h4>

                                <form id="formAuthentication"
                                      className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                                      noValidate={true} onSubmit={formik.handleSubmit}
                                      autoComplete="off"
                                >
                                    <div className="mb-3 position-relative">
                                        <InputNumeric
                                            type="text"
                                            className="text-start"
                                            dir="ltr"
                                            name="mobile"
                                            placeholder="شماره همراه خود را وارد کنید"
                                            autoComplete="off"
                                            label="شماره همراه"
                                            formik={formik}
                                            icon={ 'bx-mobile'}
                                            value={convertToWesternNumerals(formik.values.mobile) } // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formik.handleChange(e);
                                                formik.setFieldValue('mobile', convertedValue);
                                            }}

                                        />
                                    </div>

                                    <div className="mb-3 form-password-toggle">
                                        <InputPassword
                                            className="text-start"
                                            dir="ltr"
                                            name="password"
                                            placeholder="..........."
                                            formik={formik}
                                            label="رمز عبور"
                                            value={convertToWesternNumerals(formik.values.password) } // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formik.handleChange(e);
                                                formik.setFieldValue('password', convertedValue);
                                            }}
                                        />
                                    </div>
                                    <div className="mb-3 mt-4">
                                        <button className="btn btn-primary d-grid w-100" type="submit"
                                        >ورود
                                            {
                                                isLoading && <Loading/>
                                            }
                                        </button>

                                    </div>
                                </form>
                                {/*<CacheClearButton />*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>)
}